<script>
  const current_year = new Date().getFullYear();
</script>

<div class="divider"></div>

<footer id="footer" class="section">
  <div class="container">
    <div class="row">
      <span class="center-align col s12"
        >All Rights Reserved © LFCamacho, {current_year}</span
      >

      <!-- <span class="center-align col s12">Designed by <a href="https://www.creatosstudio.com" target="_blank" rel="noreferrer">Creātos Studio</a></span> -->
    </div>
  </div>
</footer>

<style>
  #footer {
    padding-top: 2em;
  }
</style>
